export const ADDRESS_STAKING_POOl1 = '0x3DCaB302d63678066196D90869c7Fe111c3Bc447';
export const ADDRESS_STAKING_POOl2 = '0xcE9417aac9859BDa2eE5807A26926835797e83C7';
export const ADDRESS_STAKING_POOl3 = '0xed5355d66BCdDE1A59B0d250C468DeDf783C14dc';
export const ADDRESS_STAKING_POOl4 = '0xb0C2cBF677652E2AaEC4c348418c36d46F54B71e';
export const ADDRESS_STAKING_POOl5 = '0xE3c0593Bf37D9420340ad78d0406a49f9a0aE1fA';
export const TOKEN_ADDRESS = '0x826e5Ec70DbC5607fF9218011FBb97F9a8D97953';